const R = require('ramda');

module.exports = function(value) {
  return Boolean(R.pathOr(false, ['value'], value))
};
